import React, {useEffect} from "react";
import {Button, Drawer, Form, Input, Select, TreeSelect,  } from "antd";
import {useModel} from "../../../models";
import {CM_ACTION_TYPE} from "../../../utils/constants";

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

const ShelveForm = () => {
    const [{materialSortDict}, {getMaterialSortDict}] = useModel("cmDict");
    const [{userInfo}] = useModel("global");
    
    useEffect(() => {
        getMaterialSortDict();
    }, []);

    const [form] = Form.useForm();
    const [
        {selectedWarehouse, selectedShelve, areaList, shelveActionType},
        {loadShelve, insertShelve, updateShelve, setShelveDrawerVisible}
    ] = useModel("warehouse");

    useEffect(() => {
        if (shelveActionType === CM_ACTION_TYPE.INSERT) {
            form.resetFields();
            form.setFieldsValue({warehouseName: !!selectedWarehouse ? selectedWarehouse.warehouseName : ""});
        } else if (shelveActionType === CM_ACTION_TYPE.EDIT) {
            // console.log(selectedShelve)
            form.resetFields();
            form.setFieldsValue(selectedShelve);
        }
    }, [shelveActionType, selectedWarehouse, selectedShelve]);


    const onFinish = () => {
        if (shelveActionType === CM_ACTION_TYPE.INSERT) {
            form.validateFields().then(async data => {
                data.warehouseId = selectedWarehouse.id;
                data.orgId = userInfo.orgId;
                data.orgName = userInfo.orgName;
                // return console.log(data)
                await insertShelve({showMsg: true, data});
                loadShelve({showMsg: false, data: {warehouseId: selectedWarehouse.id,pageSize: 10,pageNum:1}});
                setShelveDrawerVisible(false)
            });
            /*setAreaDrawerVisible(false);
            loadArea({showMsg: false, data: {warehouseId: selectedWarehouse.id}});*/
        } else if (shelveActionType === CM_ACTION_TYPE.EDIT) {
            form.validateFields().then(async data => {
            //    return  console.log(data)
                data.id = selectedShelve.id
                // data.areaId = selectedShelve.areaId
                data.orgId = userInfo.orgId;
                data.orgName = userInfo.orgName;
                await updateShelve({showMsg: true, data});
                loadShelve({showMsg: false, data: {warehouseId: selectedWarehouse.id,pageSize: 10,pageNum:1}});
                setShelveDrawerVisible(false);
            });
        }
    }

    const onReset = () => {
        form.resetFields();
        form.setFieldsValue({warehouseName: !!selectedWarehouse ? selectedWarehouse.warehouseName : ""});
        if(shelveActionType === CM_ACTION_TYPE.INSERT){

        }else if(shelveActionType === CM_ACTION_TYPE.EDIT){
            let {areaId} = selectedShelve
            form.setFieldsValue({areaId});
        }
    }
    return (
        <Form {...layout} form={form} name="control-hooks"
              onFinish={onFinish}>
            <Form.Item name="warehouseName" label="所属仓库">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="areaId" label="所属区域" rules={[{required: true, message: '货架编号字段是必输项',}]}>
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="所属区域"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={areaList.map(el => ({label: el.areaName, value: el.id}))}
                    disabled={shelveActionType === CM_ACTION_TYPE.EDIT ? true : false}
                />
            </Form.Item>
            <Form.Item name="shelvesCode" label="货架编号" rules={[{required: true, message: '货架编号字段是必输项',}]}>
                <Input />
            </Form.Item>
            <Form.Item name="shelvesName" label="货架名称" rules={[{required: true, message: '货架名称字段是必输项',}]}>
                <Input/>
            </Form.Item>
            {/* <Form.Item name="materialType" label="配件类型">
                <TreeSelect
                    showSearch
                    allowClear
                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                    placeholder="请选择商品类别"
                    treeDefaultExpandAll
                    onChange={() => {
                    }}
                    treeData={materialSortDict}
                />
            </Form.Item> */}
            <Form.Item name="shelvesDesc" label="备注" rules={[{required: false}]}>
                <Input.TextArea/>
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    {shelveActionType === CM_ACTION_TYPE.INSERT ? "添加" : "修改"}
                </Button>
                <Button htmlType="button" onClick={onReset} className="margin-left-8">
                    重置
                </Button>
            </Form.Item>
        </Form>
    );
}
export default function () {
    const [{shelveDrawerVisible}, {setShelveDrawerVisible}] = useModel("warehouse");
    return (
        <Drawer
            title="货架信息"
            placement="right"
            width={500}
            closable={true}
            onClose={() => {
                setShelveDrawerVisible(false)
            }}
            visible={shelveDrawerVisible}
        >
            <ShelveForm/>
        </Drawer>
    )
}